module.exports = __webpack_public_path__ + "static/img/img-educator-feature-3@3x.6348a70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/educator/img-educator-feature-3@3x.png
// module id = sM1M
// module chunks = 18